/* eslint-disable no-template-curly-in-string */
import { buildEditorStateFromTree } from "src/features/editor";
import {
  arrayCounterNodeDef,
  arrayNodeDef,
  expressionNodeDef,
  objectNodeDef,
  randomLengthArrayNodeDef,
  variableNodeDef,
} from "src/nodes/fako";
import { getFalsoNodeDef } from "src/nodes/falso";
import { indent } from "src/helpers/node-indent.helper";

const firstNameNodeDef = getFalsoNodeDef("randFirstName");
const lastNameNodeDef = getFalsoNodeDef("randLastName");

const basicExample = () =>
  buildEditorStateFromTree({
    nodes: [
      indent`${arrayNodeDef.create("users", { length: 3 })}`,
      indent` ${objectNodeDef.create("user")}`,
      indent`  ${arrayCounterNodeDef.create("id")}`,
      indent`  ${getFalsoNodeDef("randFirstName").create("firstName")}`,
      indent`  ${getFalsoNodeDef("randLastName").create("lastName")}`,
    ],
  });

const nestedObjectExample = () =>
  buildEditorStateFromTree({
    nodes: [
      indent`${arrayNodeDef.create("users", { length: 3 })}`,
      indent` ${objectNodeDef.create("user")}`,
      indent`  ${getFalsoNodeDef("randFirstName").create("firstName")}`,
      indent`  ${getFalsoNodeDef("randLastName").create("lastName")}`,
      indent`  ${randomLengthArrayNodeDef.create("jobs")}`,
      indent`   ${objectNodeDef.create("job")}`,
      indent`    ${getFalsoNodeDef("randJobTitle").create("title")}`,
      indent`    ${getFalsoNodeDef("randCompanyName").create("company")}`,
    ],
  });

const composedExample = () =>
  buildEditorStateFromTree({
    nodes: [
      indent`${arrayNodeDef.create("users", { length: 3 })}`,
      indent` ${objectNodeDef.create("user")}`,
      indent`  ${firstNameNodeDef.create("firstName")}`,
      indent`  ${lastNameNodeDef.create("lastName")}`,
      indent`  ${expressionNodeDef.create("greeting", {
        value: `"Hello " + firstName`,
      })}`,
    ],
  });

const variableExpressionExample = () => {
  const emailExpr = "`${name}@${provider}.${suffix}`";
  const nameExpr = "firstName + '.' + lastName";
  return buildEditorStateFromTree({
    nodes: [
      indent`${arrayNodeDef.create("users", { length: 3 })}`,
      indent` ${objectNodeDef.create("user")}`,
      indent`  ${firstNameNodeDef.create("firstName", { withAccents: false })}`,
      indent`  ${lastNameNodeDef.create("lastName", { withAccents: false })}`,
      indent`  ${expressionNodeDef.create("email", { value: emailExpr })}`,
      indent`   ${variableNodeDef.create("name", { value: nameExpr })}`,
      indent`   ${getFalsoNodeDef("randEmailProvider").create("provider")}`,
      indent`   ${getFalsoNodeDef("randDomainSuffix").create("suffix")}`,
    ],
  });
};

export const examples = [
  {
    key: "basic",
    name: "Basic",
    stateBuilder: basicExample,
  },
  {
    key: "nested",
    name: "Nested Objects",
    stateBuilder: nestedObjectExample,
  },
  {
    key: "composed",
    name: "Composed values",
    stateBuilder: composedExample,
  },
  {
    key: "variable-expression",
    name: "Variables & Expressions",
    stateBuilder: variableExpressionExample,
  },
];
